import { DataBean } from "../DataBean";

export class ProductiveProcessType extends DataBean {

    public async getProductiveProcessTypeCatalog(idProductiveProcessType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductiveProcessTypeCatalog_Number", [idProductiveProcessType]);
    }

}
